<div class="card flex justify-content-center">
    <p-breadcrumb class="max-w-full" [model]="getBreadcrumbs()"></p-breadcrumb>
</div>
<div class="container page-title">
    <div id="teamDashFlexDiv" class="flex-box"> 
        <div class="fr-flex__container">
            <div class="fr-flex__col-8">
                <h1>Teams Dashboard </h1>
            </div>
        </div>
    </div>
    <p-tabView class="fr-tabview__header__custom" id="teamDashPtabDiv"> 
        <p-tabPanel>
<form id="teamDashForm" [formGroup]="dashboardForm" *ngIf="IsShowButton">
    <div class="fr-flex__col-12">
<div class="fr-flex__container m-t-10">
    
    <div class="fr-flex__col-3">
        <div class="fr-form__group">
            <label>Engagement <em> * </em></label>
            <p-dropdown id="teamDashEng" appendTo="body" [filter]="true" [options]="engagements" placeholder="Select" optionLabel="label" optionValue="value"
                (onChange)="onTeamDashboardEngChange($event)" formControlName="dashboardEngagement"  ></p-dropdown>
                <small class="p-error" *ngIf="dashboardApplyClicked && dashboardForm?.get('dashboardEngagement')?.hasError('required')">This field is required.</small>

        </div>
    </div>
    <div class="fr-flex__col-3">
        <div class="fr-form__group">
            <label>Function <em> * </em></label>
            <p-dropdown id="teamDashFunc" [disabled]="IsFunctionDisable" appendTo="body" [filter]="true" [options]="listOfFunctions" optionLabel="label" optionValue="value"
            formControlName="dashboardFunction" placeholder="Select"  (onChange)="onTeamDashboardFunctionChange($event)"  [(ngModel)]="SelectedFunction"></p-dropdown>
            <small class="p-error" *ngIf="dashboardApplyClicked && dashboardForm?.get('dashboardFunction')?.hasError('required')">This field is required.</small>
        </div>
    </div>
    <div class="fr-flex__col-1 custom-pad-left-zero" *ngIf="IsShowButton" >
        <div class="fr-form__group">
            <label>&nbsp;</label>
            <button id="teamDashApply" [disabled]="SelectedFunction==''" class="btn btn-primary pull-left" (click)="showTeamDashboard()"> Apply</button>
            </div>
        </div>
    </div>
</div>
</form>
<div class="fr-flex__col-12"> 
<div class="fr-flex__container" *ngIf="isShowLabel">
    <div class="fr-flex__col-12">
         <h3> Onboard Associates and Laptops </h3> 
    </div>
</div>
 
<div class="fr-flex__container">
    <div class="fr-flex__col-12">
        <div class="tab-container" *ngIf="IsShowButton"> 
        <div id="dashboardContainer" class="m-b-20"></div>
        </div>
    </div>
</div>
</div>
</p-tabPanel>
</p-tabView>
<div class="margin-center"> 
    <span *ngIf="!IsShowButton"> You does not have privilage to geneare and show Darshboard </span>    
</div>
</div>

